import { create } from 'zustand';
import {
  createCalendarSlice,
  createConfigSlice,
  // createDestinationsSlice,
  createHotelDataSlice,
  createHotelGroupSlice,
  createHotelInfoSlice,
  createPopoutDirectionSlice,
  createPromoCodesSlice,
  createRoomsSlice,
  createSelectedHotelSlice,
  createThemeSlice,
  createUrlParamsSlice,
} from './slices';

const useWidgetStore = create((set, get) => ({
  ...createCalendarSlice(set, get),
  ...createConfigSlice(set, get),
  // ...createDestinationsSlice(set, get), // Restore to support multiple properties
  ...createHotelDataSlice(set, get),
  ...createHotelGroupSlice(set, get),
  ...createHotelInfoSlice(set, get),
  ...createPopoutDirectionSlice(set, get),
  ...createPromoCodesSlice(set, get),
  ...createRoomsSlice(set, get),
  ...createSelectedHotelSlice(set, get),
  ...createThemeSlice(set, get),
  ...createUrlParamsSlice(set, get),
}));

export default useWidgetStore;
